const LanguageSelector = ({ selectedLanguage, onChange }) => {
  const languages = ["English", "Yoruba", "Swahili","Nigerian Pidgin"];

  return (
    <select
      value={selectedLanguage}
      onChange={(e) => onChange && onChange(e.target.value)}
      className="w-full p-3 border rounded-md"
      disabled={!onChange} // Disable the `toLanguage` dropdown
    >
      {languages.map((lang) => (
        <option key={lang} value={lang} disabled={lang === selectedLanguage}>
          {lang}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelector;
